export const flattenObject = (
  value: Record<string, unknown>,
  prefix = '',
): Record<string, unknown> => {
  const output: Record<string, unknown> = {};

  Object.entries(value).forEach(([key, entry]) => {
    const nextKey = prefix ? `${prefix}.${key}` : key;

    if (entry instanceof Set) {
      output[nextKey] = Array.from(entry).join('::');
    } else if (Array.isArray(entry)) {
      output[nextKey] = entry.join('::');
    } else if (entry && typeof entry === 'object') {
      Object.assign(
        output,
        flattenObject(entry as Record<string, unknown>, nextKey),
      );
    } else {
      output[nextKey] = entry;
    }
  });

  return output;
};
